/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Size_Run_CategoryInputs */

const en_field_size_run_category = /** @type {(inputs: Field_Size_Run_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size run category`)
};

/**
* | output |
* | --- |
* | "Size run category" |
*
* @param {Field_Size_Run_CategoryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_size_run_category = /** @type {((inputs?: Field_Size_Run_CategoryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Size_Run_CategoryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_size_run_category(inputs)
});